<template>
  <div class="objectivesContainer">
    <div class="header"></div>
    <div class="objectivesInfo">
      <div class="infoImg">
        <div class="imgContent">
          <SvgIcon icon-class="iconicon3"></SvgIcon>
        </div>
      </div>
      <div class="infoTitle">{{target.name}}培养目标</div>
      <div class="infoContent">
        <div id="content" v-html="target.content"></div>
        <div v-for="(item, index) in list" :key="index">
          {{index + 1}}.{{item.content}}
        </div>
      </div>
    </div>
    <back-to :path="'/'"></back-to>
  </div>
</template>
<script>
import api from "@/api"
import backTo from '@/components/back'
export default {
  components: { backTo },
  data() {
    return {
      target: {},
      list: []
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.$get(api.objectives.objectives()).then(res => {
        this.target = res.target
        this.list = res.list
      })
    }
  }
}
</script>
<style lang="scss">
.objectivesContainer {
  background-color: #fff;
  .header {
    height: 318px;
    background-image: url('../../assets/bg-peiyangmubiao.png');
    background-size: 100% 100%;
  }
  .objectivesInfo {
    position: absolute;
    top: 280px;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    border-radius: 40px 40px 0px 0px;
    padding: 90px 56px 77px 50px;
    .infoImg {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      position: absolute;
      left: 50%;
      top: -60px;
      margin-left: -60px;
      background-color: #fff;
      padding: 10px;
      .imgContent {
        width: 100px;
        height: 100px;
        background-color: #E5F7F3;
        border-radius: 50%;
        text-align: center;
        line-height: 123px;
        svg {
          width:58px;
          height:54px;
        }
      }
    }
    .infoTitle {
      font-size: 30px;
      font-weight: 700;
      color: rgba(50,50,50,1);
      letter-spacing: $letter-spacing;
      text-align: center;
    }
    .infoContent {
      margin-top: 47px;
      font-size:24px;
      font-family:PingFangSC;
      font-weight:400;
      color:#696969;
      letter-spacing: $letter-spacing;
      line-height: 1.5;
      #content {
        p {
          font-size: 24px !important;
          span {
            font-size: 24px !important;
          }
        }
      }
    }
  }
}
</style>